import React from 'react';
import { useLocation } from 'react-router-dom';

const SEOHead = ({ 
  title = "Primehost - Premium Web Hosting & Design Solutions | South Africa",
  description = "Professional web hosting, email hosting, and web design services in South Africa. 99.9% uptime guarantee, 24/7 support, and local expertise in Waterfall, Midrand.",
  keywords = "web hosting, email hosting, web design, domain registration, South Africa, Midrand, Waterfall, hosting services, website design",
  // Force the same image for ALL pages - do not allow override
  image = "https://media.phst.co.za/file/ph/primehost-logo-600-sm.png",
  type = "website"
}) => {
  const location = useLocation();
  const currentUrl = `https://primehost.co.za${location.pathname}${location.search}`;

  React.useEffect(() => {
    // Update document title
    document.title = title;

    // FORCE the same image for all pages - ignore any passed image parameter
    const forcedImage = "https://media.phst.co.za/file/ph/primehost-logo-600-sm.png";

    // Update or create meta tags
    const updateMetaTag = (property, content, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attribute, property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // Basic meta tags
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);
    updateMetaTag('title', title);

    // Open Graph tags - FORCE same image
    updateMetaTag('og:title', title, true);
    updateMetaTag('og:description', description, true);
    updateMetaTag('og:image', forcedImage, true);
    updateMetaTag('og:image:secure_url', forcedImage, true);
    updateMetaTag('og:image:type', 'image/png', true);
    updateMetaTag('og:url', currentUrl, true);
    updateMetaTag('og:type', type, true);
    updateMetaTag('og:site_name', 'Primehost', true);
    updateMetaTag('og:locale', 'en_ZA', true);
    updateMetaTag('og:image:width', '600', true);
    updateMetaTag('og:image:height', '315', true);
    updateMetaTag('og:image:alt', 'Primehost - Premium Web Hosting & Design Solutions', true);

    // Twitter tags - FORCE same image
    updateMetaTag('twitter:card', 'summary_large_image', true);
    updateMetaTag('twitter:title', title, true);
    updateMetaTag('twitter:description', description, true);
    updateMetaTag('twitter:image', forcedImage, true);
    updateMetaTag('twitter:image:alt', 'Primehost - Premium Web Hosting & Design Solutions', true);
    updateMetaTag('twitter:url', currentUrl, true);
    updateMetaTag('twitter:site', '@primehost', true);
    updateMetaTag('twitter:creator', '@primehost', true);

    // WhatsApp and other messaging apps - FORCE same image
    updateMetaTag('whatsapp:image', forcedImage, true);

    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', currentUrl);

  }, [title, description, keywords, type, currentUrl]);

  return null;
};

export default SEOHead;